export var SamsungPayEventTypeEnumsObj = {
    SDK_NOT_INITIALIZED: "SDK_NOT_INITIALIZED",
    SDK_INITIALIZE_SUCCESS: "SDK_INITIALIZE_SUCCESS",
    SDK_INITIALIZE_FAIL_DEVICE_NOT_ELIGIBLE: "SDK_INITIALIZE_FAIL_DEVICE_NOT_ELIGIBLE",
    SDK_INITIALIZE_FAIL_INIT_PARAMS_ERROR: "SDK_INITIALIZE_FAIL_INIT_PARAMS_ERROR",
    SDK_REINITIALIZE_SUCCESS: "SDK_REINITIALIZE_SUCCESS",
    BUTTON_RENDERED: "BUTTON_RENDERED",
    BUTTON_NOT_RENDERED_ALREADY_EXISTS: "BUTTON_NOT_RENDERED_ALREADY_EXISTS",
    BUTTON_RENDER_FAIL_BUTTON_PARAMS_ERROR: "BUTTON_RENDER_FAIL_BUTTON_PARAMS_ERROR",
    BUTTON_RENDER_FAIL_BUTTON_CONTAINER_DOESNT_EXISTS: "BUTTON_RENDER_FAIL_BUTTON_CONTAINER_DOESNT_EXISTS",
    BUTTON_CLICK: "BUTTON_CLICK",
    IS_READY_TO_PAY_ERROR: "IS_READY_TO_PAY_ERROR",
    PAYMENT_COMPLETION_STARTING: "PAYMENT_COMPLETION_STARTING",
    PAYMENT_COMPLETION_STARTED: "PAYMENT_COMPLETION_STARTED",
    PAYMENT_COMPLETION_ERROR: "PAYMENT_COMPLETION_ERROR",
    PAYMENT_COMPLETION_OK: "PAYMENT_COMPLETION_OK",
    PAYMENT_COMPLETION_NOK: "PAYMENT_COMPLETION_NOK",
    PAYMENT_COMPLETION_REQUIRED_3DS: "PAYMENT_COMPLETION_REQUIRED_3DS",
};
